/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { RichTextComponent } from "../rich-text/rich-text";
import { isArrayNotEmpty } from "cms/utils/empty-exists";
import { SectionLinkCardsItem } from "./section-link-cards-item";
import { useScrollTargets } from "components/header/use-scroll-targets";

const SectionLinkCardsComponent = (props) => {
    const component = props?.component;
    const title = component?.title ?? "";
    const description = component?.description ?? "";
    const cards = component?.cards ?? [];

    const scrollTargets = useScrollTargets();

    return (
        <div className="section-link-cards">
            {title && <h3>{title}</h3>}
            {description && <RichTextComponent component={{ richtext: description }} />}
            {isArrayNotEmpty(cards) && (
                <div className="section-link-cards-container">
                    {cards.map((item, index) => (
                        <SectionLinkCardsItem
                            key={`section-link-card-${index}`}
                            item={item}
                            scrollTargets={scrollTargets}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

SectionLinkCardsComponent.displayName = "SectionLinkCardsComponent";
export { SectionLinkCardsComponent };
